import { Link } from "react-router-dom";

export default function SiteFooter() {
    const year = new Date().getFullYear();
    return (
        <footer className="relative overflow-hidden bg-primary text-primary-foreground">
            <div className="absolute inset-0 opacity-[0.08]" style={{ backgroundImage: "radial-gradient(circle at 20% 0%, hsl(var(--accent)) 0, transparent 40%), radial-gradient(circle at 100% 100%, hsl(var(--primary-glow)) 0, transparent 50%)" }} />
            <div className="relative mx-auto max-w-7xl px-5 sm:px-8 pt-16 pb-24 sm:pb-16">
                <div className="grid grid-cols-2 md:grid-cols-5 gap-10 md:gap-8">
                    <div className="col-span-2">
                        <div className="flex items-center gap-2">
                            <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-accent text-accent-foreground">
                                <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3v18"/><path d="M17 7H9.5a3.5 3.5 0 0 0 0 7H14a3.5 3.5 0 0 1 0 7H6"/></svg>
                            </span>
                            <span className="font-serif text-2xl">Owed</span>
                        </div>
                        <p className="mt-4 max-w-xs text-sm text-primary-foreground/70 leading-relaxed">
                            The quiet assistant that finds the real money you're owed — grants, credits, settlements, and dormant funds.
                        </p>
                        <div className="mt-6 inline-flex items-center gap-2 rounded-full bg-primary-foreground/10 border border-primary-foreground/15 px-3 py-1.5 text-xs">
                            <span className="h-1.5 w-1.5 rounded-full bg-accent animate-pulse" />
                            SOC 2 Type II in progress
                        </div>
                    </div>

                    <Col title="Product" items={[["How it works", "#how"], ["Programs", "#programs"], ["Pricing", "#pricing"], ["Security", "#faq"]]} />
                    <Col title="Company" items={[["About", "#"], ["Press", "#"], ["Careers", "#"], ["Contact", "#"]]} />
                    <Col title="Resources" items={[["Grant library", "#programs"], ["Unclaimed guide", "#"], ["Settlement tracker", "#"], ["State directory", "#"]]} />
                </div>

                <div className="mt-14 pt-8 border-t border-primary-foreground/15 flex flex-col md:flex-row justify-between gap-4 text-xs text-primary-foreground/60">
                    <p>© {year} Owed, PBC. Owed is not a lender, bank, or law firm.</p>
                    <div className="flex gap-5">
                        <Link to="#" className="hover:text-primary-foreground">Terms</Link>
                        <Link to="#" className="hover:text-primary-foreground">Privacy</Link>
                        <Link to="#" className="hover:text-primary-foreground">Accessibility</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}

function Col({ title, items }) {
    return (
        <div>
            <h4 className="text-xs uppercase tracking-[0.18em] text-primary-foreground/60">{title}</h4>
            <ul className="mt-4 space-y-3 text-sm">
                {items.map(([label, href]) => (
                    <li key={label}>
                        <a href={href} className="text-primary-foreground/85 hover:text-primary-foreground link-underline">{label}</a>
                    </li>
                ))}
            </ul>
        </div>
    );
}
